var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunnelFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 9V16.88C10.0413 17.18 9.94132 17.5 9.71132 17.71C9.32132 18.1 8.69132 18.1 8.30132 17.71L6.29132 15.7C6.06132 15.47 5.96132 15.16 6.00132 14.87V9H5.97132L0.211323 1.62C-0.128677 1.19 -0.0486774 0.56 0.381323 0.22C0.571323 0.08 0.781322 0 1.00132 0H15.0013C15.2213 0 15.4313 0.08 15.6213 0.22C16.0513 0.56 16.1313 1.19 15.7913 1.62L10.0313 9H10.0013Z",
    fill: "#242A42"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunnelFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/funnel-filter.161485db4a29bb22c1e788705481efad.svg";